import React from 'lib/react';
import { EVGrid, EVButton } from 'lib/components';
import { useTranslation } from 'lib/translation';
import { useDispatch, useSelector } from 'lib/redux';
import { Link } from 'lib/router';
import { ORDER_BLUEPRINT_ROUTE } from 'constants/RouteConstants';
import { isOrderingDisabledSelector, isEntitledForEmbeddedExplorerSelector } from 'utils/appSelectors.utils';
import MapProviderToggle from 'commonComponents/map/components/MapProviderToggle.component';
import TypeAheadSearch from './TypeAheadSearch.component';
import OrderStyles from '../OrderStyles';
import SelectField from '../../../commonComponents/select-field';
import { COUNTRY_LIST } from '../../../constants/AppConstants';
import useMediaQuery from '../../../hooks/useMediaQuery';
import { setCountryAndClearAddress } from '../Order.actions';
import { hasBlueprintProduct } from '../Order.utils';

/**
 * Component to display country dropdown and typeaheadsearch.
 */
function AddressSearch() {
  const {
    country, userProducts, bluePrintFileId, isComplex,
  } = useSelector(({
    order, userData, placeOrder,
  }) => ({
    country: order.country,
    userProducts: userData.userProducts,
    bluePrintFileId: placeOrder.bluePrintFileId,
    isComplex: order.isComplex,
  }));

  const isOrderingDisabled = useSelector(isOrderingDisabledSelector);
  const classes = OrderStyles();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(640);
  const { t } = useTranslation();

  const handleCountryChange = (event) => {
    const { target: { value } } = event;
    dispatch(setCountryAndClearAddress(value, true));
  };

  const useEE = useSelector(({ order }) => order.useEmbeddedExplorer);

  const isEmbeddedExplorerEnabled = useSelector(isEntitledForEmbeddedExplorerSelector);

  return (
    <EVGrid className={classes.addressSearchContainer}>
      <EVGrid container className={classes.addressSearch}>
        <SelectField
          variant="outlined"
          selectedValue={country}
          handleChange={handleCountryChange}
          selectOptions={isMobile ? COUNTRY_LIST.map((cntry) => ({ ...cntry, description: cntry.id })) : COUNTRY_LIST}
          className={classes.countrySelect}
          disabled={Boolean(bluePrintFileId)}
        />
        <EVGrid className={classes.addressSearchTextContainer}>
          <TypeAheadSearch />
        </EVGrid>
        {!isMobile && !isOrderingDisabled && hasBlueprintProduct(userProducts) && (
        <EVGrid container className={classes.uploadBlueprintButtonContainer}>
          {t('order__or')}
          <EVButton
            id="upload-blueprint-link"
            variant="outlined"
            color="primary"
            component={Link}
            to={ORDER_BLUEPRINT_ROUTE}
            className={classes.uploadBlueprintButton}
          >
            {t('common__upload_blueprint')}
          </EVButton>
        </EVGrid>
        )}
      </EVGrid>
      {isEmbeddedExplorerEnabled && (
        <MapProviderToggle
          className={classes.mapProviderToggle}
          useEmbeddedExplorer={useEE}
          onToggle={() => dispatch({ type: 'SET_USE_EMBEDDED_EXPLORER', useEmbeddedExplorer: !useEE })}
          disabled={isComplex}
        />
      )}
    </EVGrid>
  );
}

export default AddressSearch;
